// src/hooks/useParentHistory.js
import { useState, useEffect } from 'react';

export default function useParentHistory(chatId) {
  const [parentChatId, setParentChatId]     = useState(null);
  const [parentVersion, setParentVersion]   = useState(null);
  const [parentUsername, setParentUsername] = useState(null);
  const [parentMessages, setParentMessages] = useState([]);
  const [showParentHistory, setShowParentHistory] = useState(false);
  const [loading, setLoading]               = useState(false);

  // 1) Fetch /api/chats/{chatId} once to discover parent_*
  useEffect(() => {
    if (!chatId) return;
    fetch(`/api/chats/${chatId}`)
      .then(r => r.json())
      .then(({ parent_chat_id, parent_version, parent_username }) => {
        setParentChatId(parent_chat_id);
        setParentVersion(parent_version);
        setParentUsername(parent_username);
      })
      .catch(console.error);
  }, [chatId]);

  // 2) loadParentHistory()
  const loadParentHistory = async () => {
    if (!parentChatId) return;
    setLoading(true);
    try {
      let cutoff;
      if (parentVersion != null) {
        const info = await fetch(`/api/chats/${parentChatId}/versions/${parentVersion}`).then(r=>r.json());
        cutoff = info.created_at;
      } else {
        const meta = await fetch(`/api/chats/${chatId}`).then(r=>r.json());
        cutoff = meta.created_at;
      }
      const rows = await fetch(
        `/api/chats/${parentChatId}/messages?before=${encodeURIComponent(cutoff)}`
      ).then(r=>r.json());
      setParentMessages(rows.map(r=>({
        key:`parent-${r.sender}-${r.timestamp}`,
        sender:r.sender, text:r.content, timestamp:r.timestamp
      })));
      setShowParentHistory(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    parentChatId, parentVersion, parentUsername,
    parentMessages, showParentHistory, setShowParentHistory,
    loadParentHistory, loading
  };
}
